import { useState, useEffect } from "react";
import { Network } from "@capacitor/network";

function OfflineBanner(){
  const [offline,setOffline]=useState(!navigator.onLine);
  useEffect(()=>{
    let sub;
    /* Capacitor's Network plugin is reliable on iOS where navigator.onLine
       often stays "true" after connectivity drops. It also works fine in
       browsers (returns connected=true). */
    Network.getStatus().then(s=>setOffline(!s.connected)).catch(()=>{});
    Network.addListener("networkStatusChange",s=>setOffline(!s.connected))
      .then(handle=>{sub=handle;})
      .catch(()=>{});
    /* Fallback web events — harmless on native, catches some edge cases. */
    const on=()=>setOffline(false);
    const off=()=>setOffline(true);
    window.addEventListener("online",on);
    window.addEventListener("offline",off);
    return()=>{
      window.removeEventListener("online",on);
      window.removeEventListener("offline",off);
      try{sub&&sub.remove();}catch{}
    };
  },[]);
  if(!offline) return null;
  return <div className="offline-banner">You are offline — some features may be unavailable</div>;
}
export default OfflineBanner;
